var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInitiatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.33333C18.5 7.17428 14.8063 8.66667 10.25 8.66667C5.69365 8.66667 2 7.17428 2 5.33333M18.5 5.33333C18.5 3.49238 14.8063 2 10.25 2C5.69365 2 2 3.49238 2 5.33333M18.5 5.33333V7.83333M2 5.33333V25.3333C2 27.1743 5.69365 28.6667 10.25 28.6667M10.25 15.3333C9.99718 15.3333 9.74702 15.3287 9.5 15.3197C5.29512 15.1666 2 13.7388 2 12M10.25 22C5.69365 22 2 20.5076 2 18.6667M32 16.1667C32 18.0076 28.3063 19.5 23.75 19.5C19.1937 19.5 15.5 18.0076 15.5 16.1667M32 16.1667C32 14.3257 28.3063 12.8333 23.75 12.8333C19.1937 12.8333 15.5 14.3257 15.5 16.1667M32 16.1667V28.6667C32 30.5076 28.3063 32 23.75 32C19.1937 32 15.5 30.5076 15.5 28.6667V16.1667M32 22.4167C32 24.2576 28.3063 25.75 23.75 25.75C19.1937 25.75 15.5 24.2576 15.5 22.4167",
    stroke: "#4945FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiatedIcon);
export default __webpack_public_path__ + "static/media/initiated_icon.c7239734443b97aaf16c9e933531ceb3.svg";
export { ForwardRef as ReactComponent };